"use client";

import React from "react";
import { cn } from "utils/utils";

interface TabsListProps {
  children: React.ReactNode;
  className?: string;
  variant?: "border" | "boxed" | "lift" | null;
}

export function TabsList({
  children,
  className,
  variant = "border",
}: TabsListProps) {
  return (
    <div
      role="tablist"
      className={cn(
        "tabs min-w-max",
        {
          "tabs-border": variant === "border",
          "tabs-box": variant === "boxed",
          "tabs-lift": variant === "lift",
        },
        className
      )}
    >
      {children}
    </div>
  );
}
